import styled, { css } from 'styled-components'

import { media } from '@/theme/common'

// Note: `$fixedHeight` is for tabs whose content is a TableGroup. Its table must fill the page and
// scroll internally, so the grid row can't be sized by the table's rows (an `auto` row grows to
// fit all of them and scrolls the page) - it takes the layout's height instead, floored at a
// TableGroup's own minimum (40rem table + toolbar/pagination/padding). Other tabs keep the
// content-sized row so they can extend the page.
export const Layout = styled.div<{ $fixedHeight: boolean }>(
  ({ theme, $fixedHeight }) => css`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${theme.space['16']};

    ${media.up('md')} {
      display: grid;
      grid-template-columns: 32rem minmax(0, 1fr);
      ${$fixedHeight && 'grid-template-rows: minmax(0, 1fr);'}
      flex-shrink: 0;
      min-height: ${$fixedHeight ? '60rem' : `calc(40rem + ${theme.space['20']} * 3 + 3.2rem)`};
    }
  `,
)

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
`
